import { PricingSimpleItem } from "./drapery-item-details-fields-reducer";
import { FabricsOrLiningsItemDetailsFields } from "./fabrics-or-linings-item-details-fields-reducer";

export interface FormFields {
    pleatTypesWithPricing: PricingSimpleItem[];
    id: number;
    avatarId: string | null;
    name: string;
    itemNumber: string; //assuming alphanumeric
    itemTypeId: number;
    categoryId: number;
    subcategoryId?: number | null;
    parentCategoryId?: number;
    categoryName: string;
    supplierId: number | null;
    supplierName: string;
    customerFacingName: string | null;
    salesDescription: string;
    salesDescriptionWorkroom: string;
    orderingDescription: string;
    url: string | null;
    notes: string;
    isActive: boolean;
    isDefault: boolean;
    cost: number | "";
    msrp: number | "";
    retailPricingMethod: string;
    retailPricingValue: number | "";
    tradePricingMethod: string;
    tradePricingValue: number | "";
    shippingCost: number | "";
    sihCostType: string;
    handlingFeeMethod: string;
    handlingFeeValue: number | "";
    isProcessed?: boolean;
    columnType?: string | "";
    itemId?: number;
    itemClassId?: number;
    fabricsOrLiningsItemDetails?: FabricsOrLiningsItemDetailsFields;
    isPartialWidthRoundingOn?: boolean;
    partialWidthRoundUpTypeId?: number;
    embellishmentsWithPricing?: any;
    addOnsWithPricing?: any;
    specialityFabricsMarkUpPercentage?: string;
    draperyPinningWidthPricing?: any;
    pleatTypeListNew: any[];
    extraLargePanelsLengthInches?: string;
    extraLargePanelsWidthInches?: string;
}

export type FormFieldsPartial = Partial<FormFields>;

export type FormFieldsAction =
    | { type: "updateFormFields"; formFieldUpdates: FormFieldsPartial }
    | { type: "resetFormFields" };

export const formFieldsInitialState: FormFields = {
    id: 0,
    avatarId: "",
    name: "",
    itemNumber: "",
    itemTypeId: 0,
    categoryId: 0,
    subcategoryId: null,
    categoryName: "",
    supplierId: null,
    supplierName: "",
    customerFacingName: "",
    salesDescription: "",
    salesDescriptionWorkroom: "",
    orderingDescription: "",
    url: "",
    notes: "",
    isActive: true,
    isDefault: false,
    cost: "",
    msrp: "",
    retailPricingMethod: "",
    retailPricingValue: "",
    tradePricingMethod: "",
    tradePricingValue: "",
    shippingCost: "",
    sihCostType: "",
    handlingFeeMethod: "",
    handlingFeeValue: "",
    isProcessed: false,
    pleatTypesWithPricing: [],
    pleatTypeListNew: [],
};

export const formFieldsReducer = (
    state: FormFields,
    action: FormFieldsAction
): FormFields => {
    switch (action.type) {
        case "updateFormFields": {
            return {
                ...state,
                ...action.formFieldUpdates,
            };
        }
        case "resetFormFields": {
            return formFieldsInitialState;
        }
        default: {
            throw new Error("Invalid action type");
        }
    }
};
